import {
  USER_SIGN_IN,
  USER_GET,
  USER_SIGN_OUT,
  TEAM_LIST_GET,
  SERVICE_ENTRY_LIST_GET,
  SERVICE_ENTRY_GET,
  API_DOC_LIST_GET,
  API_LIST_SEARCH,
  API_DOC_GET,
  API_GET
} from './app.constant';

import { run } from './promise';
import { get, post } from '../utils/request';
import { getUserProfile } from '../apis/user';


export const signIn = (openLoginToken) => (
  run(
    USER_SIGN_IN,
    post('/v1/authentications/login-oauth', {
      openLoginToken: openLoginToken,
      platform: 'GOOGLE'
    })
  )
)

export const getUser = () => (
  run(
    USER_GET,
    getUserProfile()
  )
)

export const signOut = () => ({
  type: USER_SIGN_OUT
});

export const getListTeam = () => (
  run(
    TEAM_LIST_GET,
    get('/v1/teams')
  )
)

export const getListServiceEntry = (teamId) => (
  run(
    SERVICE_ENTRY_LIST_GET,
    get('/v1/teams/' + teamId + '/service-entries'),
    {
      teamId: teamId
    }
  )
)

export const getServiceEntry = (id) => (
  run(
    SERVICE_ENTRY_GET,
    get('/v1' + '/service-entries/' + id)
  )
)

export const getListApiDoc = (serviceEntryId) => (
  run(
    API_DOC_LIST_GET,
    get('/v1' + '/service-entries/' + serviceEntryId + '/api-docs')
  )
)

export const searchListApi = (q) => (
  run(
    API_LIST_SEARCH,
    get('/v1/apis/search' + '?q=' + q)
  )
)


export const loadApiDoc = (id) => (
  run(
    API_DOC_GET,
    get('/v1/api-docs/' + id)
  )
)

export const loadApi = (id) => (
  run(
    API_GET,
    get('/v1/apis/' + id)
  )
)

export const setUser = (userInfo) => {
  return {
    type: USER_GET,
    payload: userInfo
  }
}


// export const getUsers = (username, page) => (
//   run(
//     USERS_GET,
//     get('/search/users', {q: username, page: page})
//   )
// )

// export const getUserDetails = (username) => (
//   run(
//     USER_DETAILS_GET,
//     get('/users/' + username)
//   )
// )

// export const getCurrentUser = (username) => (
//   run(
//     CURRENT_USER_GET,
//     get('/users/' + username)
//   )
// )

// export const getRepos = (username) => (
//   run(
//     REPOS_GET,
//     get('/users/' + username + '/repos')
//   )
// )

// export const getFollowers = (username) => (
//   run(
//     FOLLOWER_GET,
//     get('/users/' + username + '/followers')
//   )
// )

// export const getFollowings = (username) => (
//   run(
//     FOLLOWING_GET,
//     get('/users/' + username + '/following')
//   )
// )

// export const cleanUsers = () => ({
//   type: USERS_CLEAN
// });
